module.exports = __webpack_public_path__ + "static/media/banner-essential-img.f6d9cfca.png";